import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { API, UPLOADS } from "./../../config/api";
import DateFilter from "./DateFilter";
function DynamicSupplierImage({ displayName, defaultImage, ...props }) {
  const extensions = ["jpg", "jpeg", "png", "webp", "gif", "svg"];

  const [extensionIndex, setExtensionIndex] = useState(0);
  const [useDefault, setUseDefault] = useState(false);

  const imageSrc = useDefault
    ? defaultImage
    : `/images/dashboard/${displayName}.${extensions[extensionIndex]}`;

  const handleImageError = () => {
    if (extensionIndex < extensions.length - 1) {
      setExtensionIndex((prev) => prev + 1);
    } else {
      setUseDefault(true);
    }
  };

  return (
    <img
      {...props}
      src={imageSrc}
      alt={displayName}
      onError={handleImageError}
    />
  );
}
function DynamicImage({ name, defaultImage, ...props }) {
  const extensions = ["jpg", "jpeg", "png", "webp", "gif", "svg"];
  const [index, setIndex] = useState(0);

  const src =
    index < extensions.length
      ? `/images/dashboard/${name}.${extensions[index]}`
      : defaultImage;

  return (
    <img
      {...props}
      src={src}
      alt={name}
      onError={() => {
        if (index < extensions.length - 1) {
          setIndex((prev) => prev + 1);
        }
      }}
    />
  );
}
function DashboardImageCard({
  sec,
  pendingCount,
  activeCount,
  hideCount,
  totalCount,
  navigate,
}) {
  const hasPending = pendingCount > 0;

  return (
    <div className={`dashboard-image-card ${sec.color}`}>
      {/* IMAGE */}
      <div
        className="dashboard-card-image"
        onClick={() => navigate(sec.viewPath)}
      >
        {/* {sec.section === "suppliers" ? (
          <DynamicSupplierImage
            displayName={sec.title}
            defaultImage="/images/suppliers.jpg"
          />
        ) : (
          <img src={sec.image} alt={sec.title} />
        )} */}
        {sec.section === "suppliers" ? (
          <DynamicImage
            name={sec.title}
            defaultImage="/images/suppliers.jpg"
            alt={sec.title}
          />
        ) : (
          <DynamicImage
            name={sec.imageName}
            defaultImage="/images/suppliers.jpg"
            alt={sec.title}
          />
        )}

        {/* Hover Overlay */}
        <div className="dashboard-image-overlay">
          <div className="dashboard-hover-content">
            {/* <i className="bi bi-grid-3x3-gap-fill"></i> */}
            <h3>{sec.title}</h3>
            {/* <span>View Details</span> */}
          </div>
        </div>

        {/* Pending Badge */}
        {hasPending && (
          <div className="image-pending-badge">
            <i className="bi bi-clock-history"></i>
            {pendingCount} Pending
          </div>
        )}
      </div>

      {/* CARD CONTENT */}
      <div className="dashboard-card-content">
        <div className="dashboard-card-title">
          <h4>{sec.title}</h4>

          {/* <button
            onClick={() => navigate(sec.viewPath)}
            title={`View ${sec.title}`}
          >
            <i className="bi bi-arrow-up-right"></i>
          </button> */}
        </div>

        <div className="dashboard-mini-stats">
          <button
            className="mini-stat pending"
            onClick={() =>
              navigate(sec.pendingPath, {
                state: { status: "Pending" },
              })
            }
          >
            <span>Pending</span>
            <strong>{pendingCount}</strong>
          </button>

          <button
            className="mini-stat active"
            onClick={() =>
              navigate(sec.viewPath, {
                state: { status: "Active" },
              })
            }
          >
            <span>Active</span>
            <strong>{activeCount}</strong>
          </button>

          {sec.hidePath && (
            <button
              className="mini-stat hidden"
              onClick={() =>
                navigate(sec.hidePath, {
                  state: { status: "Hide" },
                })
              }
            >
              <span>Hidden</span>
              <strong>{hideCount}</strong>
            </button>
          )}

          <button
            className="mini-stat total"
            onClick={() => navigate(sec.viewPath)}
          >
            <span>Total</span>
            <strong>{totalCount}</strong>
          </button>
        </div>
      </div>
    </div>
  );
}
export default function Dashboard() {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("User");
  const [heroImage, setHeroImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [sliders, setSliders] = useState([]);
  const [supplierTypes, setSupplierTypes] = useState([]);
  const [showVisitorModal, setShowVisitorModal] = useState(false);

  const [visitorList, setVisitorList] = useState([]);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [visitorFromDate, setVisitorFromDate] = useState("");
  const [visitorToDate, setVisitorToDate] = useState("");

  const [stats, setStats] = useState({
    machines_pending: 0,
    machines_active: 0,
    machines_hide: 0,
    machines_total: 0,

    workspace_pending: 0,
    workspace_active: 0,
    workspace_hide: 0,
    workspace_total: 0,

    designers_pending: 0,
    designers_active: 0,
    designers_total: 0,

    work_requests_pending: 0,
    work_requests_active: 0,
    work_requests_total: 0,

    // ✅ HIRING ADS
    hiring_ads_pending: 0,
    hiring_ads_active: 0,
    hiring_ads_hide: 0,
    hiring_ads_total: 0,

    supplier_counts: {},

    total_designs: 0,
    total_sales: 0,
    total_revenue: 0,
    platform_commission: 0,
    designer_earnings: 0,
    designers_list: [],
  });

  const [stats1, setStats1] = useState({
    total_visitors: 0,
    today_visitors: 0,
    yesterday_visitors: 0,
    last_7_days: 0,
    last_30_days: 0,
  });
  const fetchVisitorStatistics = useCallback(async () => {
    let url = API.VISITOR_STATISTICS;

    const params = [];

    if (visitorFromDate) params.push(`from_date=${visitorFromDate}`);
    if (visitorToDate) params.push(`to_date=${visitorToDate}`);

    if (params.length) {
      url += (url.includes("?") ? "&" : "?") + params.join("&");
    }

    try {
      const res = await fetch(url);
      const data = await res.json();

      if (data.status) {
        setStats1(data.data);
      }
    } catch (err) {
      console.log(err);
    }
  }, [visitorFromDate, visitorToDate]);
  useEffect(() => {
    fetchVisitorStatistics();
  }, [fetchVisitorStatistics]);
  const fetchSupplierTypes = async () => {
    try {
      const res = await fetch(`${API.BASE_URL}/api.php?action=supplier_types`);
      const data = await res.json();
      if (data.status) {
        setSupplierTypes(data.data);
      }
    } catch (err) {
      console.log("Supplier fetch error", err);
    }
  };

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (user) {
      setUserName(user.name);
    }
    fetchSliders();
    fetchSupplierTypes();
  }, []);

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    // ==============================
    // MAX 5 MB
    // ==============================
    const maxFileSize = 5 * 1024 * 1024; // 5 MB

    if (file.size > maxFileSize) {
      alert("Hero slider image must be 5 MB or smaller.");

      // Clear selected file
      e.target.value = "";

      setHeroImage(null);
      setPreview(null);

      return;
    }

    // ==============================
    // SET IMAGE
    // ==============================
    setHeroImage(file);

    const objectUrl = URL.createObjectURL(file);
    setPreview(objectUrl);
  };

  useEffect(() => {
    return () => {
      if (preview) URL.revokeObjectURL(preview);
    };
  }, [preview]);

  const uploadHeroSlider = async () => {
    if (!heroImage) {
      alert("Please select an image");
      return;
    }
    const formData = new FormData();
    formData.append("image", heroImage);

    try {
      const res = await fetch(API.ADD_HERO_SLIDER, {
        method: "POST",
        body: formData,
      });
      const data = await res.json();
      if (data.status) {
        alert("Slider Image Uploaded Successfully");
        setHeroImage(null);
        setPreview(null);
        fetchSliders();
      } else {
        alert(data.message || "Upload failed");
      }
    } catch (err) {
      console.error(err);
    }
  };

  const fetchSliders = async () => {
    try {
      const res = await fetch(API.GET_HERO_SLIDER);
      const data = await res.json();
      if (data.status) setSliders(data.data);
    } catch (err) {
      console.error(err);
    }
  };

  const deleteSlider = async (id) => {
    const formData = new FormData();
    formData.append("id", id);
    try {
      const res = await fetch(API.DELETE_HERO_SLIDER, {
        method: "POST",
        body: formData,
      });
      const data = await res.json();
      if (data.status) {
        alert("Deleted Successfully");
        fetchSliders();
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const fetchDashboardData = useCallback(async () => {
    try {
      let url = API.ADMIN_DASHBOARD;
      const queryParams = [];

      if (fromDate) queryParams.push(`from_date=${fromDate}`);
      if (toDate) queryParams.push(`to_date=${toDate}`);

      if (queryParams.length > 0) {
        const separator = url.includes("?") ? "&" : "?";
        url += `${separator}${queryParams.join("&")}`;
      }

      const res = await fetch(url);
      const data = await res.json();

      if (!data.status) {
        console.log("Dashboard API failed");
        return;
      }

      setStats({
        machines_pending: Number(data.machines?.pending || 0),
        machines_active: Number(data.machines?.active || 0),
        machines_hide: Number(data.machines?.hide || 0),
        machines_total: Number(data.machines?.total || 0),

        workspace_pending: Number(data.workspaces?.pending || 0),
        workspace_active: Number(data.workspaces?.active || 0),
        workspace_hide: Number(data.workspaces?.hide || 0),
        workspace_total: Number(data.workspaces?.total || 0),
        // ✅ HIRING ADS
        hiring_ads_pending: Number(data.hiring_ads?.pending || 0),
        hiring_ads_active: Number(data.hiring_ads?.active || 0),
        hiring_ads_hide: Number(data.hiring_ads?.hide || 0),
        hiring_ads_total: Number(data.hiring_ads?.total || 0),
        designers_pending: Number(data.designers?.pending || 0),
        designers_active: Number(data.designers?.active || 0),
        designers_total: Number(data.designers?.total || 0),
        work_requests_pending: Number(data.work_requests?.pending || 0),
        work_requests_active: Number(data.work_requests?.active || 0),
        work_requests_total: Number(data.work_requests?.total || 0),
        supplier_counts: {
          ...data.supplier_counts,

          machines: {
            pending: Number(data.machines?.pending || 0),
            active: Number(data.machines?.active || 0),
            hide: Number(data.machines?.hide || 0),
            total: Number(data.machines?.total || 0),
          },

          workspace: {
            pending: Number(data.workspaces?.pending || 0),
            active: Number(data.workspaces?.active || 0),
            hide: Number(data.workspaces?.hide || 0),
            total: Number(data.workspaces?.total || 0),
          },

          designers: {
            pending: Number(data.designers?.pending || 0),
            active: Number(data.designers?.active || 0),
            hide: Number(data.designers?.hide || 0),
            total: Number(data.designers?.total || 0),
          },

          sketchers: {
            pending: Number(data.sketchers?.pending || 0),
            active: Number(data.sketchers?.active || 0),
            hide: Number(data.sketchers?.hide || 0),
            total: Number(data.sketchers?.total || 0),
          },
          // ✅ HIRING ADS
          hiring_ads: {
            pending: Number(data.hiring_ads?.pending || 0),
            active: Number(data.hiring_ads?.active || 0),
            hide: Number(data.hiring_ads?.hide || 0),
            total: Number(data.hiring_ads?.total || 0),
          },
          // ADD THIS
          work_requests: {
            pending: Number(data.work_requests?.pending || 0),
            active: Number(data.work_requests?.active || 0),
            hide: 0,
            total: Number(data.work_requests?.total || 0),
          },
        },

        total_designs: Number(data.total_designs || 0),
        total_sales: Number(data.total_sales || 0),
        total_revenue: Number(data.total_revenue || 0),
        platform_commission: Number(data.platform_commission || 0),
        designer_earnings: Number(data.designer_earnings || 0),
        designers_list: data.designers_list || [],
      });
    } catch (error) {
      console.error("Dashboard Error:", error);
    }
  }, [fromDate, toDate]);
  useEffect(() => {
    fetchDashboardData();
  }, [fetchDashboardData]);
  const getVisitorHistory = async () => {
    let url = `${API.BASE_URL}/api.php?action=visitor_history`;

    const params = [];

    if (visitorFromDate) params.push(`from_date=${visitorFromDate}`);

    if (visitorToDate) params.push(`to_date=${visitorToDate}`);

    if (params.length) {
      url += "&" + params.join("&");
    }

    const res = await fetch(url);
    const data = await res.json();

    if (data.status) {
      setVisitorList(data.data);
      setShowVisitorModal(true);
    }
  };
  const dynamicSections = [
    {
      title: "Machines",
      imageName: "machine",
      color: "blue",
      viewPath: "/admin/view-machine",
      pendingPath: "/admin/view-machine",
      hidePath: "/admin/view-machine",
      prefix: "machines",
      section: "marketplace",
    },

    {
      title: "Workspaces",
      imageName: "workspace",
      color: "orange",
      viewPath: "/admin/view-workspace",
      pendingPath: "/admin/view-workspace",
      hidePath: "/admin/view-workspace",
      prefix: "workspace",
      section: "marketplace",
    },

    {
      title: "Bid Design Work",
      imageName: "bidwork",
      color: "red",
      viewPath: "/admin/view-work",
      pendingPath: "/admin/view-work",
      hidePath: null,
      prefix: "work_requests",
      section: "management",
    },

    {
      title: "Designers",
      imageName: "designer",
      color: "green",
      viewPath: "/admin/view-designer",
      pendingPath: "/admin/view-designer",
      hidePath: null,
      prefix: "designers",
      section: "management",
    },

    {
      title: "Sketchers",
      imageName: "Sketchers",
      color: "purple",
      viewPath: "/admin/view-sketcher",
      pendingPath: "/admin/view-sketcher",
      hidePath: null,
      prefix: "sketchers",
      section: "management",
    },

    {
      title: "Hiring",
      imageName: "hiring",
      color: "orange",
      viewPath: "/admin/view-hiring-ads",
      pendingPath: "/admin/view-hiring-ads",
      hidePath: "/admin/view-hiring-ads",
      prefix: "hiring_ads",
      section: "management",
    },
  ];
  const supplierSections = supplierTypes.map((item, index) => ({
    title: item.display_name,
    color: ["purple", "teal", "red", "blue"][index % 4],

    viewPath: `/admin/manage-supplier/${item.type}`,
    pendingPath: `/admin/manage-supplier/${item.type}`,
    hidePath: `/admin/manage-supplier/${item.type}`,

    prefix: item.type,
    section: "suppliers",
  }));

  return (
    <div className="dashboard-wrapper">
      <style>{`
       
      `}</style>

      {/* Top Welcome Bar */}
      <div className="dashboard-top">
        <div className="header-info">
          <h2>
            Welcome Back{" "}
            <i className="bi bi-hand-thumbs-up-fill text-warning"></i>
          </h2>
          <p className="username">{userName}</p>
        </div>
        <button className="customer-btn" onClick={() => navigate("/")}>
          <i className="bi bi-globe"></i> Website Visit
        </button>
      </div>

      {/* Visitor Statistics */}
      <div className="visitor-stats-wrapper mb-4">
        <div className="visitor-card">
          <div className="visitor-stats">
            <div className="visitor-item stats-box">
              <i className="bi bi-calendar-day-fill"></i>
              <div>
                <h4>{stats1.today_visitors}</h4>
                <span>Today's Visitors</span>
              </div>
            </div>
            <div className="visitor-item stats-box">
              <i className="bi bi-calendar-minus-fill"></i>
              <div>
                <h4>{stats1.yesterday_visitors}</h4>
                <span>Yesterday's Visitors</span>
              </div>
            </div>
            <div className="visitor-item stats-box">
              <i className="bi bi-calendar-week-fill"></i>
              <div>
                <h4>{stats1.last_7_days}</h4>
                <span>Last 7 Days</span>
              </div>
            </div>

            <div className="visitor-item stats-box">
              <i className="bi bi-calendar3-fill"></i>
              <div>
                <h4>{stats1.last_30_days}</h4>
                <span>Last 30 Days</span>
              </div>
            </div>
            <div className="visitor-item stats-box">
              <i className="bi bi-people-fill"></i>
              <div>
                <h4>{stats1.total_visitors}</h4>
                <span>Total Visitors</span>
              </div>
            </div>
          </div>

          <div className="visitor-actions">
            {/* <button className="visitor-view-btn" onClick={getVisitorHistory}>
              <i className="bi bi-eye-fill"></i>
            </button> */}

            <DateFilter
              fromDate={visitorFromDate}
              toDate={visitorToDate}
              setFromDate={setVisitorFromDate}
              setToDate={setVisitorToDate}
            />

            <button className="visitor-view-btn" onClick={getVisitorHistory}>
              <i className="bi bi-eye-fill"></i>
            </button>
          </div>
        </div>
      </div>
      <div
        className="mb-4 me-5"
        style={{ display: "flex", justifyContent: "end" }}
      >
        <div>
          {" "}
          <DateFilter
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
          />
        </div>
      </div>

      {(() => {
        const allSections = [...dynamicSections, ...supplierSections];
        const pendingSections = allSections.filter(
          (sec) => (stats.supplier_counts[sec.prefix]?.pending || 0) > 0,
        );

        if (pendingSections.length === 0) return null;

        return (
          <div
            className="card shadow-sm mb-4 border-0"
            style={{
              backgroundColor: "#fffdf4",
              border: "1px solid #fef08a !important",
              borderRadius: "16px",
            }}
          >
            <div className="card-body p-1 w-100">
              <div className="d-flex align-items-center mb-3">
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{
                    width: "40px",
                    height: "40px",
                    backgroundColor: "#fef9c3",
                    color: "#ca8a04",
                  }}
                >
                  <i className="bi bi-bell-fill fs-5"></i>
                </div>
                <div>
                  <h5
                    className="card-title fw-bold mb-0 text-start"
                    style={{ color: "#713f12" }}
                  >
                    Action Required
                  </h5>
                  <p className="card-text text-muted small mb-0">
                    You have pending requests waiting for your review.
                  </p>
                </div>
              </div>

              <div className="row g-3">
                {pendingSections.map((sec) => {
                  const pendingCount =
                    stats.supplier_counts[sec.prefix]?.pending || 0;
                  return (
                    <div
                      className="col-md-3 col-sm-6"
                      key={`alert-${sec.title}`}
                    >
                      <div
                        className="p-3 bg-white rounded-3 shadow-sm d-flex justify-content-between align-items-center transition-all"
                        style={{
                          cursor: "pointer",
                          border: "1px solid #e2e8f0",
                          transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.borderColor = "#facc15";
                          e.currentTarget.style.transform = "translateY(-2px)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.borderColor = "#e2e8f0";
                          e.currentTarget.style.transform = "translateY(0)";
                        }}
                        onClick={() =>
                          navigate(sec.pendingPath, {
                            state: { status: "Pending" },
                          })
                        }
                      >
                        <div className="d-flex align-items-center gap-3">
                          {sec.section === "suppliers" ? (
                            <DynamicSupplierImage
                              displayName={sec.title}
                              defaultImage="/images/suppliers.jpg"
                              style={{
                                width: "76px",
                                height: "76px",
                                objectFit: "contain",
                                borderRadius: "8px",
                                background: "#f8fafc",
                                padding: "4px",
                              }}
                            />
                          ) : (
                            <DynamicImage
                              name={sec.imageName}
                              defaultImage="/images/suppliers.jpg"
                              alt={sec.title}
                              style={{
                                width: "76px",
                                height: "76px",
                                objectFit: "contain",
                                borderRadius: "8px",
                                background: "#f8fafc",
                                padding: "4px",
                              }}
                            />
                          )}
                          <div>
                            <h6 className="mb-0 fw-bold text-dark">
                              {sec.title}
                            </h6>
                            <span
                              className="text-muted"
                              style={{ fontSize: "0.75rem" }}
                            >
                              Click to review
                            </span>
                          </div>
                        </div>

                        <span
                          className="badge rounded-pill px-3 py-2 fw-bold"
                          style={{
                            backgroundColor: "#fef9c3",
                            color: "#854d0e",
                            fontSize: "0.75rem",
                            border: "1px solid #fde047",
                          }}
                        >
                          {pendingCount} Pending
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        );
      })()}

      {/* Grid containing cards */}
      <div className="dashboard-sections">
        <div className="dashboard-section">
          <div className="dashboard-section-header">
            <div>
              <span className="section-subtitle">MANAGEMENT</span>
              <h2>Work & Professionals</h2>
            </div>

            <div className="section-line"></div>
          </div>

          <div className="dashboard-card-grid">
            {dynamicSections
              .filter((sec) => sec.section === "management")
              .map((sec) => {
                const pendingCount =
                  stats.supplier_counts[sec.prefix]?.pending || 0;

                const activeCount =
                  stats.supplier_counts[sec.prefix]?.active || 0;

                const hideCount = stats.supplier_counts[sec.prefix]?.hide || 0;

                const totalCount =
                  stats.supplier_counts[sec.prefix]?.total || 0;

                return (
                  <DashboardImageCard
                    key={sec.title}
                    sec={sec}
                    pendingCount={pendingCount}
                    activeCount={activeCount}
                    hideCount={hideCount}
                    totalCount={totalCount}
                    navigate={navigate}
                  />
                );
              })}
          </div>
        </div>
        {/* ================= MARKETPLACE ================= */}
        <div className="dashboard-section">
          <div className="dashboard-section-header">
            <div>
              <span className="section-subtitle">MARKETPLACE</span>
              <h2>Machines & Workspaces</h2>
            </div>

            <div className="section-line"></div>
          </div>

          <div className="dashboard-card-grid">
            {dynamicSections
              .filter((sec) => sec.section === "marketplace")
              .map((sec) => {
                const pendingCount =
                  stats.supplier_counts[sec.prefix]?.pending || 0;

                const activeCount =
                  stats.supplier_counts[sec.prefix]?.active || 0;

                const hideCount = stats.supplier_counts[sec.prefix]?.hide || 0;

                const totalCount =
                  stats.supplier_counts[sec.prefix]?.total || 0;

                return (
                  <DashboardImageCard
                    key={sec.title}
                    sec={sec}
                    pendingCount={pendingCount}
                    activeCount={activeCount}
                    hideCount={hideCount}
                    totalCount={totalCount}
                    navigate={navigate}
                  />
                );
              })}
          </div>
        </div>

        {/* ================= SUPPLIERS ================= */}
        {supplierSections.length > 0 && (
          <div className="dashboard-section">
            <div className="dashboard-section-header">
              <div>
                <span className="section-subtitle">MARKETPLACE</span>
                <h2>Suppliers</h2>
              </div>

              <div className="section-line"></div>
            </div>

            <div className="dashboard-card-grid">
              {supplierSections.map((sec) => {
                const pendingCount =
                  stats.supplier_counts[sec.prefix]?.pending || 0;

                const activeCount =
                  stats.supplier_counts[sec.prefix]?.active || 0;

                const hideCount = stats.supplier_counts[sec.prefix]?.hide || 0;

                const totalCount =
                  stats.supplier_counts[sec.prefix]?.total || 0;

                return (
                  <DashboardImageCard
                    key={sec.title}
                    sec={sec}
                    pendingCount={pendingCount}
                    activeCount={activeCount}
                    hideCount={hideCount}
                    totalCount={totalCount}
                    navigate={navigate}
                  />
                );
              })}
            </div>
          </div>
        )}

        {/* ================= MANAGEMENT ================= */}
      </div>

      {/* Advanced Component Upload Segment Panels */}
      <div className="management-panel">
        {/* Dropzone Upload */}
        <div className="panel-box">
          <h3>
            <i className="bi bi-upload text-primary"></i> Hero Slider Upload
          </h3>
          <div className="upload-dropzone">
            <input type="file" accept="image/*" onChange={handleImageChange} />

            <div className="dropzone-text">
              <i
                className="bi bi-cloud-arrow-up"
                style={{ fontSize: "2.5rem", display: "block" }}
              ></i>
              Choose an image file or drag it here
              <small
                style={{
                  display: "block",
                  marginTop: "8px",
                  color: "#ac1313",
                  fontWeight: "600",
                }}
              >
                Maximum file size: 5 MB
              </small>
            </div>
          </div>
          {preview && (
            <div className="preview-wrapper">
              <img src={preview} alt="Upload preview" />
            </div>
          )}
          <button className="action-btn1" onClick={uploadHeroSlider}>
            <i className="bi bi-cloud-plus-fill"></i> Upload Image Banner
          </button>
        </div>

        {/* Dynamic Display Grid */}
        <div className="panel-box">
          <h4>
            <i className="bi bi-images text-primary"></i> Active Slider
            Galleries
          </h4>
          <div className="media-grid">
            {sliders.map((item) => (
              <div className="media-card" key={item.id}>
                <button
                  className="trash-btn"
                  onClick={() => deleteSlider(item.id)}
                >
                  <i className="bi bi-trash3-fill"></i>
                </button>
                <img
                  src={`${UPLOADS.SLIDER_IMAGE}${item.image}`}
                  alt="Slider carousel asset"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      {showVisitorModal && (
        <div
          className="visitor-modal-overlay"
          onClick={() => {
            setShowVisitorModal(false);
            setVisitorList([]);
          }}
        >
          <div className="visitor-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content1">
              <div className="modal-header">
                <h5>Visitor Report</h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowVisitorModal(false);
                    setVisitorList([]);
                  }}
                ></button>
              </div>

              <div className="modal-body">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Date</th>

                      <th>Visitors</th>
                    </tr>
                  </thead>

                  <tbody>
                    {visitorList.map((item, index) => (
                      <tr key={index}>
                        <td>{item.visit_date}</td>

                        <td>{item.daily_visitors}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
